module.exports = __webpack_public_path__ + "static/footer-right-vector-1bb7f2103aaf62d0277e294852c2cc68.svg";